export const colors = {
	white: "#ffffff",
	gray: "#2F3136",
	gray2: "#727478",
	black: "#2F3136",
	primary: "#FF6D60",
};

export const type_colors = {
	bug: "ab2",
	dark: "754",
	dragon: "76e",
	electric: "fc3",
	fairy: "e9e",
	fighting: "b54",
	fire: "f42",
	flying: "89f",
	ghost: "66b",
	grass: "7c5",
	ground: "db5",
	ice: "6cf",
	normal: "aa9",
	poison: "a59",
	psychic: "f59",
	rock: "ba6",
	steel: "aab",
	water: "39f",
};
